/** Labels of the monitoring categories, for the dashboard tiles. */
export const CATEGORY_LABELS: Record<string, string> = {
  jobs: "Jobs",
  carriers: "Transporteurs",
  stripe: "Stripe",
  emails: "Emails",
  shops: "Boutiques",
  users: "Utilisateurs",
  security: "Sécurité",
  rgpd: "RGPD",
  general: "Général",
};

export function categoryLabel(category: string): string {
  return CATEGORY_LABELS[category] ?? category;
}
